import ga4 from 'react-ga4';

let TRACKING_ID = 'G-J4T5WWDLBM'; //default local
const isProduction = process.env.NODE_ENV === 'production';
let isLocal = false;

if (typeof window !== 'undefined') {
  const hostName = window.location.hostname.toLowerCase();
  if (hostName.includes('local')) {
    TRACKING_ID = 'G-J4T5WWDLBM';
    isLocal = true;
  } else if (hostName.includes('dev')) {
    TRACKING_ID = 'G-VH22LGZMB8';
  } else if (hostName.includes('qa')) {
    TRACKING_ID = 'G-NFK6TF1NK4';
  } else if (hostName.includes('next.eepass.org')) {
    TRACKING_ID = 'G-MHYM2Q89HN';
  }
}

// >>> FIX: Remove GA4 initialization here.
// GA4 is now initialized inside useAuth.js with user_id.
// initParams stays only for config reuse.
const initParams = { 
  trackingId: TRACKING_ID,
  send_page_view: false,
  gaOptions: { debug_mode: isLocal },
  gtagOptions: { debug_mode: isLocal }
};

// >>> FIX: Remove init() call; no longer safe for user_id timing.
export const init = () => {
  console.warn("GA init() is no longer used. GA4 is initialized in useAuth.js instead.");
};

// Track last page for dedupe
let _currentUserId = null;
let _lastSentPage = { path: null, ts: 0 };

export const SetUserProperties = (userInfo, globalConfig) => {
  if (!window.gtag || !userInfo || !globalConfig) {
    return;
  }

  const userTitle = globalConfig.observationConfig.UserPositionAlternativeMap
    .find(x => x.UserPosition === userInfo.UserPositionType)?.Name;

  const newUserProps = {
    user_roles: userInfo.Roles,
    user_title: userTitle ?? userInfo.Title,
    org_name: globalConfig.OrganizationNames,
    district_name: globalConfig.DistrictNames,
    school_name: globalConfig.SchoolNames,
    user_profile_id: userInfo.UserId
  };

  // >>> FIX: user_id is already set by useAuth; do NOT overwrite here.
  window.gtag('set', 'user_properties', newUserProps);
};

export const TrackPageView = async (location, appUserMgr) => {
  const path = `${location?.pathname ?? ''}${location?.search ?? ''}`;

  if (_lastSentPage.path === path && (Date.now() - _lastSentPage.ts) < 8000) {
    return;
  }

  const ready = await waitForGa4Ready();
  if (!ready) return;

  const globalState = await waitForGlobalState(appUserMgr);
  const userInfo = globalState?.userProfile;

  if (userInfo) {
    SetUserProperties(userInfo, globalState);
  }

  window.gtag('event', 'page_view', {
    page_path: path,
    page_location: window.location.href,
    page_title: document.title
  });

  _lastSentPage = { path, ts: Date.now() };
};

  export const resetGA4OnLogout = () => {
    // Remove persisted user_id
    localStorage.removeItem("ga4_user_id");

    // Clear GA4 cookies
    const gaCookies = document.cookie
      .split(";")
      .filter(cookie => cookie.trim().startsWith("_ga"));
    
    gaCookies.forEach(cookie => {
      const cookieName = cookie.split("=")[0].trim();
      document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    });

    try {
      // Reinitialize with no user_id to start fresh
      ga4.initialize(TRACKING_ID, {
        gtagOptions: { 
          user_id: null,
          // Force new client_id on next initialization
          client_id: undefined
        }
      });
      
      // Clear any set user properties
      ga4.set({ user_id: null });
      ga4.gtag('set', 'user_properties', {});
      
    } catch(e) {
      console.error("GA reset failed:", e);
    }
  }

export const HandleLogout = () => {
  setGAUserId(undefined);

  window.gtag('set', 'user_properties', {
    user_roles: undefined,
    user_title: undefined,
    org_name: undefined,
    district_name: undefined,
    school_name: undefined,
    user_profile_id: undefined
  });

  window.gtag('config', TRACKING_ID, initParams);
  resetGA4OnLogout();
};

export const AddEvent = async (eventTypeEnum, value, content, mgr) => {
  const ready = await waitForGa4Ready();
  if (!ready) return;

  const globalState = await waitForGlobalState(mgr);
  const userInfo = globalState?.userProfile;

  let eventData = eventTypeObjects[eventTypeEnum];
  if (!eventData) return;

  eventData.value = value;

  if (content) {
    if (eventData.category.toLowerCase() === "content") {
      eventData = {
        ...eventData,
        content_type_name: content.ContentTypeName,
        label: content.Title,
        page_location: window.location.href,
        page_title: document.title
      };
    }

    if (eventTypeEnum == EventTypeEnum.Content_Accessed) {
      eventData = {
        ...eventData,
        content_path: getContentPath(content),
        content_type_name: content.ContentTypeName,
        title: content.Title,
        mime_type: content.MimeType,
        file_type: content.FileExt,
        page_location: window.location.href,
        page_title: content.title
      };
    }
  } else {
    eventData = {
      ...eventData,
      page_path: window.location.pathname,
      page_location: window.location.href,
      page_title: document.title
    };
  }

  if (userInfo) {
    SetUserProperties(userInfo, globalState);
  }

  if (eventTypeEnum == EventTypeEnum.Auth_Logout) {
    HandleLogout();
  }

  window.gtag('event', eventData.category, eventData);
};

const getContentPath = (content) => {
  const path = window.location.protocol + "//" + window.location.host;
  return path + "/content/?k=" + content.KeyId;
};

export const waitForGa4Ready = async (timeoutMs = 5000) => {
  const start = Date.now();
  while ((!window.gtag || typeof window.gtag !== 'function') &&
         Date.now() - start < timeoutMs) {
    await new Promise(res => setTimeout(res, 50));
  }
  return !!window.gtag;
};

export const waitForGlobalState = async (appUserMgr, timeoutMs = 5000) => {
  const start = Date.now();
  let globalState = appUserMgr?.GetGlobalState();

  while (!globalState && Date.now() - start < timeoutMs) {
    await new Promise(res => setTimeout(res, 50));
    globalState = appUserMgr?.GetGlobalState();
  }
  return globalState ?? null;
};

// >>> FIX: Correct GA4 field name: user_id (NOT userId)
export const setGAUserId = (userId) => {
  if (_currentUserId === userId) return;

  _currentUserId = userId ?? null;

  ga4.set({ user_id: userId ?? undefined });
};

export const EventTypeEnum = {
  Auth_Login: 1,
  Auth_Logout: 2,
  Content_Download: 3,
  Content_Accessed: 4,
  Content_Shared: 5,
  View_Report: 6
};

export const eventTypeObjects = {
  [EventTypeEnum.Auth_Login]: { category: "auth", action: "User Logged In" },
  [EventTypeEnum.Auth_Logout]: { category: "auth", action: "User Logged Out" },
  [EventTypeEnum.Content_Download]: { category: "content", action: "Download" },
  [EventTypeEnum.Content_Accessed]: { category: "content", action: "View" },
  [EventTypeEnum.Content_Shared]: { category: "content", action: "Shared" },
  [EventTypeEnum.View_Report]: { category: "reporting", action: "View" }
};

export { ga4, TRACKING_ID };
